import { env } from "@/utils/env";
import Script from "next/script";
declare global {
  interface Window {
    amplitude: any;
  }
}

const Amplitude = () => {
  const handleLoad = () => {
    // Ensure amplitude is available on window
    if (typeof window?.amplitude === "undefined") return;
    try {
      window?.amplitude
        ?.getInstance()
        ?.init(env.NEXT_PUBLIC_AMPLITUDE_API_KEY || "", undefined, {
          saveEvents: true,
          includeUtm: true,
          includeReferrer: true,
        });
    } catch (error) {
      console.error("Failed to initialize Amplitude:", error);
    }
  };

  return (
    <Script
      strategy="afterInteractive"
      src="https://cdn.amplitude.com/libs/amplitude-8.16.0-min.gz.js"
      onLoad={handleLoad}
    />
  );
};

export default Amplitude;
